import { Trans } from 'react-i18next';

import { useAmelioTranslations } from '@/hooks';

export interface SurveyAnswerDescriptionProps {
    isSelfEvaluation: boolean;
    selfEvaluationDescription: string;
    managerLabel: string;
    /** An anonymous 360 still tells who reads the answers, and adds that they come without the name. */
    isAnonymous?: boolean;
    /** Said instead of the usual promise when the person evaluated launched the 360 and reads its results. */
    revieweeSees?: string;
}

export const SurveyAnswerDescription = ({
    isSelfEvaluation,
    selfEvaluationDescription,
    managerLabel,
    isAnonymous = false,
    revieweeSees,
}: SurveyAnswerDescriptionProps) => {
    const { t } = useAmelioTranslations();

    if (isSelfEvaluation) {
        return selfEvaluationDescription;
    }

    return (
        <Trans
            i18nKey={
                isAnonymous
                    ? 'answer.surveyAnswer.featureItem.anonymousDescription'
                    : 'answer.surveyAnswer.featureItem.description'
            }
            values={{
                managerLabel,
                revieweeSees:
                    revieweeSees ?? t('answer.surveyAnswer.featureItem.revieweeSeesNoAnswer'),
            }}
        />
    );
};
